// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d067a56","455":"5e22e086","977":"234fe41a"}[chunkId] + ".chunk.js";
};